import { Box, Paper, AppBar, Stack, Toolbar, Typography } from "@mui/material";
// Images
import cimicardImage from "../../../Images/cimicard-image.jpg";
import Image from "next/image";

const HeaderInfo = () => {
    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                <Paper square variant="outlined" elevation={1}>
                <AppBar position="fixed" sx={{ bgcolor: 'white' }}>
                    <Toolbar>
                        <Box sx={{ width: { xs: 120, sm: 197 }, flexShrink: 0 }}>
                            <Image src={cimicardImage} alt="CimiCard Logo" width={197} height={52} style={{ width: '100%', height: 'auto' }} />
                        </Box>
                        <Typography sx={{ flexGrow: 1 }} />
                            <Stack sx={{ minWidth: 0 }}>
                            <Typography align="right" variant="h4" color="primary" noWrap
                                sx={{ fontSize: { xs: '1.1rem', sm: '1.5rem', md: '2.125rem' } }}>
                                VCO Cash-Out Request<sup style={{ fontSize: '45%' }}>†</sup>
                            </Typography>
                        </Stack>
                    </Toolbar>
                </AppBar>
                </Paper>
            </Box>
        </div>
    )
}

export default HeaderInfo;